import { jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import { Widget } from './Widget';
import * as Styles from './FloatingWidgetPlaceholder.module.scss';
export function FloatingWidgetPlaceholder(props) {
    return (_jsx("div", { className: Styles.floating_placeholder, children: props.widgets.map(([widget, placement], index) => (_jsx("div", { className: Styles.frame, children: _jsx(Widget, { id: widget.id, widget: widget, type: Common.WidgetSize.Frame, placementManager: props.placementManager, placeholderType: Common.WidgetPlaceholderType.Floating, placement: placement }) }, index))) }));
}
